import React from 'react';
import ReactDOM from 'react-dom';
import Instruction from '../components/instruction/Instruction';
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderInstruction = (elementId, props) => {
    const element = document.getElementById(elementId);
    if (element) {

        initializeI18n()
            .then((i18nInstance) => {
                ReactDOM.render(<Instruction props={props} />, element);
            })
            .catch(error => {
                //console.error("Failed to initialize i18n before rendering RealTimeLectureDetail:", error);
            });

    } else {
        //console.error(`Element with ID ${elementId} not found.`);
    }
};